const infractionIntegrationStatus = {
  acknowledgedInfractionBalanceBlockPending: 'acknowledged_infraction_balance_block_pending',
  acknowledgedInfractionBalanceBlockSucceeded: 'acknowledged_infraction_balance_block_succeeded',
  disagreedInfractionBalanceUnlockPending: 'disagreed_infraction_balance_unlock_pending',
  disagreedInfractionBalanceUnlockSucceeded: 'disagreed_infraction_balance_unlock_succeeded',
  expiredInfractionBalanceUnlockPending: 'expired_infraction_balance_unlock_pending',
  expiredInfractionBalanceUnlockSucceeded: 'expired_infraction_balance_unlock_succeeded',
  cancelledInfractionBalanceUnlockPending: 'cancelled_infraction_balance_unlock_pending',
  cancelledInfractionBalanceUnlockSucceeded: 'cancelled_infraction_balance_unlock_succeeded'
};

module.exports = infractionIntegrationStatus;
